var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1F22",
    d: "M5.103 10.836a20.83 20.83 0 0 0 9.06 9.062l3.026-3.026a1.37 1.37 0 0 1 1.402-.33c1.54.51 3.204.784 4.909.784.756 0 1.375.619 1.375 1.375V23.5c0 .756-.619 1.375-1.375 1.375C10.589 24.875.125 14.411.125 1.5.125.744.744.125 1.5.125h4.813c.756 0 1.375.619 1.375 1.375 0 1.719.275 3.369.783 4.909a1.38 1.38 0 0 1-.344 1.402z"
  })));
};
export default SvgPhone;